import React from 'react';
import PropTypes from 'prop-types';
import { Calendar, Views, momentLocalizer } from 'react-big-calendar';
import withDragAndDrop from 'react-big-calendar/lib/addons/dragAndDrop';
import moment from 'moment';
import _capitalize from 'lodash/capitalize';
// Core components
import withThemeColors from 'components/core/hocs/WithThemeColors';
// Models
import { weekStartDate, weekScrollToTime, weekEventFormatter } from 'models/planning';
// Custom
import { themeColorsShape } from 'constants/PropTypesShapes';
import { dateFormatter } from 'utils/DateUtils';

// Header for columns (display day in current locale)
const WeekCalendarHeader = ({ date }) => (
  <div>{_capitalize(dateFormatter.toDayOfWeek(date))}</div>
);

WeekCalendarHeader.propTypes = {
  date: PropTypes.instanceOf(Date).isRequired,
};

// Formats for events
const weekCalendarFormats = {
  eventTimeRangeFormat: ({ start, end }) => weekEventFormatter(start, end),
  eventTimeRangeStartFormat: ({ start }) => weekEventFormatter(start),
  eventTimeRangeEndFormat: ({ end }) => weekEventFormatter(null, end),
};

// Apply theme color to each event
const eventPropGetter = (color) => ({
  style: {
    backgroundColor: color,
    borderColor: color,
  },
});

// When needed, set first day of week to Monday
// moment.locale("es-es", {
//   week: {
//     dow: 1 //Monday is the first day of the week.
//   }
// });

// Localize the calendar according to moment configuration
const localizer = momentLocalizer(moment);

// Add drag&drop addon to calendar
const DragAndDropCalendar = withDragAndDrop(Calendar);

const WeekCalendar = ({
  themeColors, events, selectable, scrollToTime, onSelectEvent, onSelectSlot, onEventDrop, onEventResize,
}) => {
  const calendarProps = {
    localizer,
    events,
    selectable,
    toolbar: false,
    defaultView: Views.WEEK,
    components: { week: { header: WeekCalendarHeader } },
    messages: { allDay: null },
    drilldownView: null,
    showMultiDayTimes: true,
    defaultDate: weekStartDate(),
    step: 15,
    timeslots: 4,
    formats: weekCalendarFormats,
    scrollToTime,
    eventPropGetter: () => eventPropGetter(themeColors.primary),
    onSelectEvent,
    onSelectSlot,
    onEventDrop,
    onEventResize,
  };

  // Use D&D calendar only if selectable
  if (selectable) {
    return (
      <DragAndDropCalendar {...calendarProps} />
    );
  }
  return (
    <Calendar {...calendarProps} />
  );
};

WeekCalendar.propTypes = {
  themeColors: themeColorsShape.isRequired,
  events: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      start: PropTypes.instanceOf(Date).isRequired,
      end: PropTypes.instanceOf(Date).isRequired,
    }).isRequired,
  ).isRequired,
  selectable: PropTypes.bool,
  scrollToTime: PropTypes.instanceOf(Date),
  onSelectEvent: PropTypes.func.isRequired,
  onSelectSlot: PropTypes.func.isRequired,
  onEventDrop: PropTypes.func.isRequired,
  onEventResize: PropTypes.func.isRequired,
};

WeekCalendar.defaultProps = {
  selectable: false,
  scrollToTime: weekScrollToTime(),
};

module.exports = withThemeColors(WeekCalendar);



// WEBPACK FOOTER //
// ./components/plannings/WeekCalendar.js